export default "__VITE_PUBLIC_ASSET__d47d4f10__"